var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"pa-16",staticStyle:{"background-color":"#3A3A3A","font-family":"Poppins"},attrs:{"align":"center"}},[_c('v-col',{attrs:{"align":"center"}},[_c('h1',{staticClass:"px-10 white--text pt-0"},[_vm._t("default")],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }